import React from 'react';

import { token } from '@/theme';
import { getWidgetFillColor, getWidgetSecondaryFillColor } from '@/comp/MapBuilder/utils/utils';

const AerationBasinWidget = ({
  isSelected,
  className,
  width = 241,
  height = 144,
}: {
  width: number;
  height: number;
  isSelected?: boolean;
  className?: string;
}) => {
  const widgetFillColor = getWidgetFillColor(isSelected, token);
  const widgetSecondaryFillColor = getWidgetSecondaryFillColor(isSelected, token);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 241 144"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="WWT---Map" transform="translate(-1418, -815)">
          <g id="Group-4" transform="translate(1418, 815)">
            <g id="Group-7-Copy">
              <g id="devices/production_floor/body">
                <polygon
                  id="BG"
                  fill={widgetFillColor}
                  transform="translate(120.0524, 72) scale(-1, 1) translate(-120.0524, -72)"
                  points="-1.42581844e-17 3.90954256e-12 240.104741 3.15043718e-14 212.72684 144 26.6655426 144"
                ></polygon>
                <path
                  d="M10,66 L12,66 C13.1045695,66 14,66.8954305 14,68 L14,76 C14,77.1045695 13.1045695,78 12,78 L10,78 L10,78 L10,66 Z"
                  id="In_Out-Copy-4"
                  fill={widgetSecondaryFillColor}
                  fillRule="nonzero"
                  transform="translate(12, 72) rotate(170) translate(-12, -72)"
                ></path>
              </g>
              <g
                id="Group"
                transform="translate(120.0524, 29.9512) scale(1, -1) translate(-120.0524, -29.9512)"
                fill={widgetFillColor}
                fillRule="nonzero"
              >
                <path
                  d="M0,59.9024003 L10.53,4.363 L10.5362029,4.38839704 C10.5756196,4.52573097 10.7711574,4.93782564 11.1228165,5.62468104 L11.2139838,5.80211907 C12.5504402,8.39467139 17.0307796,10.2535809 20.6750089,10.2535809 C24.3192382,10.2535809 27.7392073,8.63659691 30.0939401,5.80211907 C32.8402951,2.47486082 36.7411148,0.43099908 40.9609983,0.0608700193 L41.0026582,0 C41.0645506,0.013989836 41.1262371,0.0280316515 41.1877177,0.0421254465 C41.5730104,0.0143414172 41.9623039,0 42.3535013,0 C47.1003436,0 51.5668605,2.11159088 54.6130625,5.80211907 C56.8552632,8.501138 60.0633184,10.0962499 63.5111518,10.2425456 C66.3984907,10.1217219 69.1194701,9.013009 71.2601508,7.11060424 L71.259512,7.03863625 C71.259512,6.58207606 71.4111044,6.14453921 71.7142891,5.80211907 C74.8029833,2.11159088 79.331805,0 84.1448623,0 C84.2785583,0 84.412035,0.00162931395 84.5452676,0.00487652523 L84.5640361,0.00487652523 L84.9644414,0 C85.0897815,0 85.2149288,0.00143201421 85.3398629,0.00428663563 L85.710486,0 C87.3221899,0 88.789884,0.301915554 90.1447939,0.845180903 C92.9398318,1.78424035 95.4522909,3.48085441 97.3950146,5.80211907 C97.6981994,6.14453921 97.8497917,6.58207606 97.8497917,7.03863625 L97.8491529,7.11060424 C100.11996,9.12865144 103.04376,10.2535809 106.125754,10.2535809 C109.820818,10.2535809 113.288493,8.63659691 115.676072,5.80211907 C118.764767,2.11159088 123.293588,0 128.106646,0 C132.919703,0 137.448524,2.11159088 140.537219,5.80211907 C142.924798,8.63659691 146.392473,10.2535809 150.087537,10.2535809 C153.782601,10.2535809 157.250276,8.63659691 159.637856,5.80211907 C162.472823,2.41475612 166.521033,0.357575892 170.888691,0.042452437 C171.14109,0.0205584413 171.397887,0.0075180571 171.658475,0.00243120716 L171.783084,0.00060889834 L172.068429,0 L172.274,0.002 L172.467655,0 C177.147017,0 181.557714,1.99590958 184.637529,5.49824142 L184.898229,5.80211907 C187.192084,8.52532981 190.482901,10.1247558 194.014502,10.24613 C197.49777,10.1247963 200.743368,8.5253643 203.005694,5.80211907 C206.051896,2.11159088 210.518413,0 215.265256,0 C220.012098,0 224.478615,2.11159088 227.524817,5.80211907 C228.210228,6.62717374 229.308714,7.65583986 230.820274,8.88811744 L240.104741,59.9024003 L0,59.9024003 Z"
                  id="Combined-Shape"
                ></path>
              </g>
            </g>
            <g id="Group-3" transform="translate(46.3146, 134.2496)" fill={widgetFillColor}>
              <rect id="Rectangle" x="0" y="6.09402896" width="146.256695" height="3.65641738"></rect>
              <rect id="Rectangle-Copy-2" x="8.53164055" y="0" width="17.0632811" height="6.09402896"></rect>
              <rect id="Rectangle-Copy-3" x="36.5641738" y="0" width="17.0632811" height="6.09402896"></rect>
              <rect id="Rectangle-Copy-4" x="64.596707" y="0" width="17.0632811" height="6.09402896"></rect>
              <rect id="Rectangle-Copy-6" x="92.6292402" y="0" width="17.0632811" height="6.09402896"></rect>
              <rect id="Rectangle-Copy-8" x="120.661773" y="0" width="17.0632811" height="6.09402896"></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default AerationBasinWidget;
